import { IBridgeOptions } from './interface'

/**
 * 容器事件，仅在原生运行下有效
 * 当app应用从后台回到前台时会触发 appAppear 事件 <br>
 * 参考 http://document.lightyy.com/zh-cn/api/olight-event.html#appappear
 * @param {IBridgeOptions} { success, fail, complete }
 */
function appAppearSync({ success, fail, complete }: IBridgeOptions) {
  if (window.LightJSBridge) {
    window.LightJSBridge.AppWillEnterForeground = () => {
      success && success()
      complete && complete()
    }
  } else {
    fail && fail()
    complete && complete()
  }
}

/**
 * 容器事件，仅在原生运行下有效
 * 当app应用从后台回到前台时会触发 appAppear 事件 <br>
 * 参考 http://document.lightyy.com/zh-cn/api/olight-event.html#appappear
 * 一个异步接口，支持 Promise 化使用
 * @returns
 */
function appAppear() {
  return new Promise((resolve, reject) => {
    if (window.LightJSBridge) {
      window.LightJSBridge.AppWillEnterForeground = () => {
        resolve()
      }
    } else {
      reject('window.LightJSBridge 对象不存在')
    }
  })
}

export { appAppearSync }
